import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=2487cd2c&scoped=true&"
import script from "./Primary.vue?vue&type=script&lang=js&"
export * from "./Primary.vue?vue&type=script&lang=js&"
import style0 from "./Primary.vue?vue&type=style&index=0&id=2487cd2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487cd2c",
  null
  
)

export default component.exports